__turbopack_context__.v({
  "SCooperation": "j2ysra_SCooperation",
  "SDesktopCmsImageForAssetRef": "j2ysra_SDesktopCmsImageForAssetRef",
  "SFilmwebLogoSvg": "j2ysra_SFilmwebLogoSvg",
  "SMobileCmsImageForAssetRef": "j2ysra_SMobileCmsImageForAssetRef",
  "SSGLogo": "j2ysra_SSGLogo",
  "SSponsorLink": "j2ysra_SSponsorLink",
  "SStreamingguideLogo": "j2ysra_SStreamingguideLogo",
  "STopOfPageSponsorContainer": "j2ysra_STopOfPageSponsorContainer",
  "STopOfPageSponsorOuterContainer": "j2ysra_STopOfPageSponsorOuterContainer",
  "STrackingPixel": "j2ysra_STrackingPixel",
  "hasDesktop": "j2ysra_hasDesktop",
  "hasMobile": "j2ysra_hasMobile",
  "hideSponsorTextMobile": "j2ysra_hideSponsorTextMobile",
  "sponsor": "j2ysra_sponsor",
});
